import {AfterViewInit, Component, Inject, OnInit, Renderer2} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Router} from '@angular/router';
import {StorageService} from "../../../_services/storage.service";
import {UserService} from 'src/app/_services/user.service';
import { AlertService } from 'src/app/_services/alert.service';
import { AuthService } from 'src/app/_services/auth.service';
import { MenusService } from 'src/app/_services/menu.service';
import { interval, Subscription } from 'rxjs';
import { InactivityService } from 'src/app/_helpers/inactivity-check-service';
declare var googleTranslateElementInit: Function;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, AfterViewInit {
  profileData: any;
  fullName: any;
  Name: any;
  timeLeft: number = 10 * 60; // 30 minutes in seconds
  displayTime: string = '30:00';
  private timerSubscription: Subscription | undefined;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private storageService: StorageService,
    private userService: UserService,
    private alertService: AlertService,
    private authService: AuthService,
    private menuService: MenusService,
    public inactivityService: InactivityService
  ) {
  }

  ngAfterViewInit(): void {
    googleTranslateElementInit()
  }

  ngOnInit(): void {
     this.userService.getUserProfileNew().subscribe((data) => {
      this.profileData = data;
      this.fullName = localStorage.getItem('username')
      var a = this.fullName.split(' ')[0]
      var b = this.fullName.split(' ')[1]
      this.Name = (this.fullName.split(' ')[1])?(a.substring(0, 1)+b.substring(0, 1)).toUpperCase():a.substring(0, 2).toUpperCase()
      localStorage.setItem( "user",this.profileData?.USERID)
      const {Menu} = data;
      const menuData = this.menuService.structuredMenu(this.menuService.transformApiResponse(data.data))
      // if (menuData.finalMenus[0].ROLENAME =="Reseller" ) {
      // // if (menuData.finalMenus[0].ROLENAME =="Reseller"||menuData.finalMenus[0].ROLENAME =="Merchant" ) {
      //   this.alertService.errorAlert({
      //     title: "No Access! Contact Administrator",
      //     backdrop: true,
      //     toast: true,
      //     timer: 1800,
      //     position:'top-end'
      //   })
      //   this.inactivityService.stopInactivityTracking();
      //   this.authService.logout('manual');  // Manual logout from navbar
      // }
    })
    // Object.defineProperty(String.prototype, 'capitalize', {
    //   value: function() {
    //     return this.charAt(0).toUpperCase() + this.slice(1);
    //   },
    //   enumerable: false
    // });

    // this.userService.getUserProfile().subscribe((data)=>{
    //   this.profileData = data;
    //   this.profileName = this.profileData.fullName.capitalize()
    // })
  }

  /**
   * Click on toggle sidebar
   * @param event
   */
  toggleSidebar(event: Event): void {
    event.preventDefault();
    if (this.document.body.classList.contains('sidebar-open')) {
      this.document.body.classList.remove('sidebar-open');
    } else {
      this.document.body.classList.add('sidebar-open');
    }
  }

  /**
   * Logout
   * @param event
   */
  onLogout(e: Event) {
    e.preventDefault();
    console.log('🔓 Navbar logout clicked - calling AuthService.logout()');
    
    // Call the proper logout method which will:
    // 1. Log the logout activity via HTTP interceptor
    // 2. Clean storage
    // 3. Stop inactivity tracking
    // 4. Navigate to login page
    this.authService.logout('manual');  // Manual logout from navbar
  }

  onChangePassword(e: Event) {
    e.preventDefault();
    this.router.navigate(['/change-password']);
  }

  language(){
    console.log("Select language Clicked");
    googleTranslateElementInit();
  }


}
